import React from 'react';
import { Box, Stack, Text } from 'braid-design-system';
import type { RecentInvoiceResponse } from '../../services/invoiceService';
import type { PrintPaperSize } from '../../utils/posPrintRenderer';
import PrintSizeToggle from './PrintSizeToggle';

interface ReceiptPrintModalProps {
  receipt: RecentInvoiceResponse;
  printPaperSize: PrintPaperSize;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onPaperSizeChange: (paperSize: PrintPaperSize) => void;
}

const ReceiptPrintModal: React.FC<ReceiptPrintModalProps> = ({
  receipt,
  printPaperSize,
  isLoading,
  onCancel,
  onConfirm,
  onPaperSizeChange,
}) => {
  return (
    <div className="search-modal-overlay">
      <div className="search-modal billing-receipt-print-modal">
        <div className="search-modal-header">
          <div>
            <Text weight="strong" size="large">
              Print Receipt
            </Text>
            <div className="billing-receipt-print-subtitle">
              <Text tone="secondary" size="small">
                Invoice {receipt.invoice_no}
              </Text>
            </div>
          </div>
          <button
            type="button"
            onClick={() => {
              if (!isLoading) {
                onCancel();
              }
            }}
            className="search-modal-close"
            disabled={isLoading}
          >
            x
          </button>
        </div>

        <div className="search-modal-content billing-receipt-print-content">
          <Stack space="medium">
            <PrintSizeToggle
              value={printPaperSize}
              onChange={onPaperSizeChange}
              disabled={isLoading}
              disablePos={Boolean(receipt.tax_per)}
              label="Receipt print size"
            />

            <Text>
              Want to print this receipt again?
            </Text>

            <Box display="flex" justifyContent="spaceBetween" alignItems="center">
              <Text tone="secondary" size="small">
                {receipt.customer_name || 'Walk-in'}
              </Text>
              <Text weight="strong">
                {receipt.amount.toFixed(2)}
              </Text>
            </Box>

            <Box display="flex" justifyContent="flexEnd" gap="small">
              <button
                type="button"
                className="billing-bottom-btn clear"
                onClick={onCancel}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="billing-bottom-btn charge"
                onClick={onConfirm}
                disabled={isLoading}
              >
                {isLoading ? 'Printing...' : `Print (${printPaperSize})`}
              </button>
            </Box>
          </Stack>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPrintModal;
